import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Right Digital">
                            <h2>Avail The Right Digital Strategy Consulting</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>TekRevol is an experienced contender, developing state-of-the-art digital solutions for
                            enterprises and medium-sized businesses and enabling them for a digitally sustainable
                            future.</p>
                        <p>Our digital strategy consulting provides extensive support to businesses in identifying the
                            rightful path and help them progress better in a highly competitive environment.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;